module.exports = __webpack_public_path__ + "static/media/jiantou.07f9a1d9.png";